import _ from 'lodash';
import type {Context} from '../types';
import {generateGuid} from '@packages/utilities/guid';

export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {nodeMap},
    fn: {insertNodesAfter},
  } = context;
  const {type} = jsonNode;
  const needed =
    type === 'CommerceCartCheckoutActions' &&
    _.find(jsonNode.children, (childId) => {
      const childNode = nodeMap.get(childId);
      return childNode && childNode.type === 'CommerceCartCheckoutButton';
    }) &&
    !_.find(jsonNode.children, (childId) => {
      const childNode = nodeMap.get(childId);
      return childNode && childNode.type === 'CommerceCartQuickCheckoutActions';
    });

  return {
    needed: Boolean(needed),
    logData: {
      msg: 'Quick Checkout Actions should be added to each Checkout Actions in a Cart',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const commerceCartQuickCheckoutActionsId = generateGuid();
      const commerceCartQuickCheckoutButtonId = generateGuid();
      const commerceCartGoogleIconId = generateGuid();
      const commerceCartMicrosoftIconId = generateGuid();
      const commerceCartQuickCheckoutButtonTextBlockId = generateGuid();
      const commerceCartQuickCheckoutButtonTextId = generateGuid();
      const commerceCartApplePayButtonId = generateGuid();
      const commerceCartApplePayIconId = generateGuid();

      const quickCheckoutActionsNode = [
        {
          _id: commerceCartQuickCheckoutActionsId,
          type: 'CommerceCartQuickCheckoutActions',
          tag: 'div',
          data: {
            commerce: {
              type: 'cart-quick-checkout-actions',
            },
          },
          children: [
            commerceCartApplePayButtonId,
            commerceCartQuickCheckoutButtonId,
          ],
        },
        {
          _id: commerceCartApplePayButtonId,
          type: 'CommerceCartApplePayButton',
          tag: 'div',
          children: [commerceCartApplePayIconId],
        },
        {
          _id: commerceCartApplePayIconId,
          type: 'CommerceCartApplePayIcon',
          tag: 'div',
        },
        {
          _id: commerceCartQuickCheckoutButtonId,
          type: 'CommerceCartQuickCheckoutButton',
          tag: 'div',
          children: [
            commerceCartGoogleIconId,
            commerceCartMicrosoftIconId,
            commerceCartQuickCheckoutButtonTextBlockId,
          ],
        },
        {
          _id: commerceCartGoogleIconId,
          type: 'CommerceQuickCheckoutGoogleIcon',
          tag: 'div',
        },
        {
          _id: commerceCartMicrosoftIconId,
          type: 'CommerceQuickCheckoutMicrosoftIcon',
          tag: 'div',
        },
        {
          _id: commerceCartQuickCheckoutButtonTextBlockId,
          type: 'Block',
          tag: 'div',
          data: {
            tag: 'div',
            text: true,
          },
          children: [commerceCartQuickCheckoutButtonTextId],
        },
        {
          _id: commerceCartQuickCheckoutButtonTextId,
          text: true,
          v: 'Pay with browser',
        },
      ];

      _.each(jsonNode.children, (childId, index) => {
        const childNode = nodeMap.get(childId);
        // we insert the quick checkout actions before the checkout button
        // so that quick checkout actions appear above the checkout button
        // we do this by finding the child before the checkout button
        // and inserting the nodes after that
        if (childNode && childNode.type === 'CommerceCartCheckoutButton') {
          // either insert before the child before the checkout button, or if there's none
          // then on the checkout actions itself, as this means we only have a checkout button
          // inside of checkout actions
          const previousElementId =
            (jsonNode.children && jsonNode.children[index - 1]) || jsonNode._id;
          jsonNode.children &&
            jsonNode.children.splice(
              previousElementId !== jsonNode._id ? index : 0,
              0,
              commerceCartQuickCheckoutActionsId
            );
          insertNodesAfter(previousElementId, quickCheckoutActionsNode);
        }
      });
    },
  };
};
